import { computed, inject, Injectable } from '@angular/core';
import { CompanyService, FreightCarrierStoreService } from '@okcargo-apps/shared-application-ionic';

@Injectable({
  providedIn: 'root',
})
export class NoticeService {
  private readonly companyService = inject(CompanyService);
  private readonly freightCarrierStoreService = inject(FreightCarrierStoreService);

  public readonly hasNotices = computed(
    () =>
      this.companyService.expiredOrNotUploadedDocuments().length > 0 ||
      this.freightCarrierStoreService.freightsWithPendingDocumentation().items.length > 0 ||
      this.freightCarrierStoreService.freightsWithoutDeliveryNoteInPaperReceived().items.length > 0,
  );
}
